import api from '@/api';
import {
  GPActivityCalendar,
  GPActivityCalendarRequest,
  GPActivityCreateRequest,
  GPActivityCreateResponse,
  GPActivityDetail,
  GPActivityEditRequest,
  GPActivityListRequest,
  GPActivityListResponse,
  GPActivityObservation,
  GPActivityObservationCreateRequest,
  GPActivityObservationDeleteRequest,
  GPActivityObservationEditRequest,
  GPActivityStatusChangeRequest,
} from './activities.types';

const BASE = '/visual-management/activities';

export default {
  async create(data: GPActivityCreateRequest) {
    const res = (await api.post(BASE, data)) as unknown;
    return res as GPActivityCreateResponse;
  },

  async detail(activityId?: string) {
    const res = (await api.get(`${BASE}/${activityId}`, null)) as unknown;
    return res as GPActivityDetail;
  },

  async delete(activityId?: string) {
    const res = (await api.remove(
      `${BASE}/${activityId}`,
      {},
      null,
    )) as unknown;
    return res as GPActivityCreateResponse;
  },

  async edit({ activityId, ...data }: GPActivityEditRequest) {
    const res = await api.put(`${BASE}/${activityId}`, data, null);
    return res;
  },

  async list(params: GPActivityListRequest) {
    const res = (await api.get(BASE, params)) as unknown;
    return res as GPActivityListResponse;
  },

  async statusChange({ activityId, ...data }: GPActivityStatusChangeRequest) {
    const res = await api.patch(`${BASE}/${activityId}/status`, data, null);
    return res;
  },

  async calendar(params: GPActivityCalendarRequest) {
    const res = (await api.get(`${BASE}/calendar`, params)) as unknown;
    return res as GPActivityCalendar[];
  },

  async generateWorkOrder({
    activityId,
    ...body
  }: {
    vehicleId?: number;
    activityId: string;
  }) {
    const res = await api.post(
      `${BASE}/${activityId}/generate-work-order`,
      body,
    );
    return res.data;
  },

  async observationCreate({
    activityId,
    ...data
  }: GPActivityObservationCreateRequest) {
    const result = await api.post(`${BASE}/${activityId}/observations`, data);

    return result.data;
  },

  async observationList(activityId?: string) {
    const res = (await api.get(
      `${BASE}/${activityId}/observations`,
      null,
    )) as unknown;
    return res as GPActivityObservation[];
  },

  async observationEdit({
    activityId,
    observationId,
    ...data
  }: GPActivityObservationEditRequest) {
    const res = await api.put(
      `${BASE}/${activityId}/observations/${observationId}`,
      data,
      null,
    );
    return res.data;
  },

  async observationDelete(data: GPActivityObservationDeleteRequest) {
    const result = (await api.remove(
      `${BASE}/${data.activityId}/observations/${data.observationId}`,
      {},
      null,
    )) as unknown;

    return result as void;
  },
};
